import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pbg-telestration-rules',
  templateUrl: './telestration-rules.component.html',
  styleUrls: ['./telestration-rules.component.scss']
})
export class TelestrationRulesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
